import React from "react";
import { StyledBookmarkIconOff, StyledBookmarkIconOn, StyledButton } from "./styles";
export const BookmarkButton = ({
  className,
  isBookmarked,
  onClick
}) => {
  const handleClick = event => {
    onClick === null || onClick === void 0 || onClick(isBookmarked ? "unbookmark" : "bookmark", event);
  };
  return /*#__PURE__*/React.createElement(StyledButton, {
    "aria-label": isBookmarked ? "unbookmark" : "bookmark",
    className: className,
    onClick: handleClick,
    "data-qa": "bookmark-button"
  }, isBookmarked ? /*#__PURE__*/React.createElement(StyledBookmarkIconOn, null) : /*#__PURE__*/React.createElement(StyledBookmarkIconOff, null));
};
BookmarkButton.displayName = "BookmarkButton";